export var IconSymbol;
(function (IconSymbol) {
    IconSymbol[IconSymbol["Add"] = 0] = "Add";
    IconSymbol[IconSymbol["Adsr"] = 1] = "Adsr";
    IconSymbol[IconSymbol["ArrayDown"] = 2] = "ArrayDown";
    IconSymbol[IconSymbol["AudioBus"] = 3] = "AudioBus";
    IconSymbol[IconSymbol["AudioDevice"] = 4] = "AudioDevice";
    IconSymbol[IconSymbol["AudioFile"] = 5] = "AudioFile";
    IconSymbol[IconSymbol["AutoGain"] = 6] = "AutoGain";
    IconSymbol[IconSymbol["Automation"] = 7] = "Automation";
    IconSymbol[IconSymbol["BassGuitar"] = 8] = "BassGuitar";
    IconSymbol[IconSymbol["Book"] = 9] = "Book";
    IconSymbol[IconSymbol["Box"] = 10] = "Box";
    IconSymbol[IconSymbol["Browse"] = 11] = "Browse";
    IconSymbol[IconSymbol["Maximizer"] = 12] = "Maximizer";
    IconSymbol[IconSymbol["Bug"] = 13] = "Bug";
    IconSymbol[IconSymbol["Fold"] = 14] = "Fold";
    IconSymbol[IconSymbol["Checkbox"] = 15] = "Checkbox";
    IconSymbol[IconSymbol["Clips"] = 16] = "Clips";
    IconSymbol[IconSymbol["Close"] = 17] = "Close";
    IconSymbol[IconSymbol["CloudFolder"] = 18] = "CloudFolder";
    IconSymbol[IconSymbol["Code"] = 19] = "Code";
    IconSymbol[IconSymbol["CollapseDown"] = 20] = "CollapseDown";
    IconSymbol[IconSymbol["Compressor"] = 21] = "Compressor";
    IconSymbol[IconSymbol["Connected"] = 22] = "Connected";
    IconSymbol[IconSymbol["Cube"] = 23] = "Cube";
    IconSymbol[IconSymbol["Cursor"] = 24] = "Cursor";
    IconSymbol[IconSymbol["Curve"] = 25] = "Curve";
    IconSymbol[IconSymbol["Dattorro"] = 26] = "Dattorro";
    IconSymbol[IconSymbol["Delete"] = 27] = "Delete";
    IconSymbol[IconSymbol["Dial"] = 28] = "Dial";
    IconSymbol[IconSymbol["DinSlot"] = 29] = "DinSlot";
    IconSymbol[IconSymbol["Disconnected"] = 30] = "Disconnected";
    IconSymbol[IconSymbol["Divide"] = 31] = "Divide";
    IconSymbol[IconSymbol["DragConnections"] = 32] = "DragConnections";
    IconSymbol[IconSymbol["Dropdown"] = 33] = "Dropdown";
    IconSymbol[IconSymbol["Dropbox"] = 34] = "Dropbox";
    IconSymbol[IconSymbol["DrumSet"] = 35] = "DrumSet";
    IconSymbol[IconSymbol["Tidal"] = 36] = "Tidal";
    IconSymbol[IconSymbol["Duration"] = 37] = "Duration";
    IconSymbol[IconSymbol["EditBox"] = 38] = "EditBox";
    IconSymbol[IconSymbol["Effects"] = 39] = "Effects";
    IconSymbol[IconSymbol["Embed"] = 40] = "Embed";
    IconSymbol[IconSymbol["EQ"] = 41] = "EQ";
    IconSymbol[IconSymbol["Eraser"] = 42] = "Eraser";
    IconSymbol[IconSymbol["Exclude"] = 43] = "Exclude";
    IconSymbol[IconSymbol["Exit"] = 44] = "Exit";
    IconSymbol[IconSymbol["ExpandWidth"] = 45] = "ExpandWidth";
    IconSymbol[IconSymbol["FileList"] = 46] = "FileList";
    IconSymbol[IconSymbol["Film"] = 47] = "Film";
    IconSymbol[IconSymbol["Flask"] = 48] = "Flask";
    IconSymbol[IconSymbol["Focus"] = 49] = "Focus";
    IconSymbol[IconSymbol["Gate"] = 50] = "Gate";
    IconSymbol[IconSymbol["Generator"] = 51] = "Generator";
    IconSymbol[IconSymbol["GoogleDrive"] = 52] = "GoogleDrive";
    IconSymbol[IconSymbol["Groove"] = 53] = "Groove";
    IconSymbol[IconSymbol["Guitar"] = 54] = "Guitar";
    IconSymbol[IconSymbol["GuitarTab"] = 55] = "GuitarTab";
    IconSymbol[IconSymbol["Headphone"] = 56] = "Headphone";
    IconSymbol[IconSymbol["Heart"] = 57] = "Heart";
    IconSymbol[IconSymbol["Help"] = 58] = "Help";
    IconSymbol[IconSymbol["HighPass"] = 59] = "HighPass";
    IconSymbol[IconSymbol["HighShelf"] = 60] = "HighShelf";
    IconSymbol[IconSymbol["Insert"] = 61] = "Insert";
    IconSymbol[IconSymbol["Invert"] = 62] = "Invert";
    IconSymbol[IconSymbol["Info"] = 63] = "Info";
    IconSymbol[IconSymbol["Lock"] = 64] = "Lock";
    IconSymbol[IconSymbol["Loop"] = 65] = "Loop";
    IconSymbol[IconSymbol["LoopEnd"] = 66] = "LoopEnd";
    IconSymbol[IconSymbol["LoopStart"] = 67] = "LoopStart";
    IconSymbol[IconSymbol["LowPass"] = 68] = "LowPass";
    IconSymbol[IconSymbol["LowShelf"] = 69] = "LowShelf";
    IconSymbol[IconSymbol["Magnet"] = 70] = "Magnet";
    IconSymbol[IconSymbol["MainMenu"] = 71] = "MainMenu";
    IconSymbol[IconSymbol["Maximized"] = 72] = "Maximized";
    IconSymbol[IconSymbol["Menu"] = 73] = "Menu";
    IconSymbol[IconSymbol["Merge"] = 74] = "Merge";
    IconSymbol[IconSymbol["Metronome"] = 75] = "Metronome";
    IconSymbol[IconSymbol["Microphone"] = 76] = "Microphone";
    IconSymbol[IconSymbol["Midi"] = 77] = "Midi";
    IconSymbol[IconSymbol["Minimized"] = 78] = "Minimized";
    IconSymbol[IconSymbol["Mix"] = 79] = "Mix";
    IconSymbol[IconSymbol["Mixing"] = 80] = "Mixing";
    IconSymbol[IconSymbol["Mute"] = 81] = "Mute";
    IconSymbol[IconSymbol["NanoWave"] = 82] = "NanoWave";
    IconSymbol[IconSymbol["NeuralAmp"] = 83] = "NeuralAmp";
    IconSymbol[IconSymbol["New"] = 84] = "New";
    IconSymbol[IconSymbol["NoAudio"] = 85] = "NoAudio";
    IconSymbol[IconSymbol["Note"] = 86] = "Note";
    IconSymbol[IconSymbol["NotePad"] = 87] = "NotePad";
    IconSymbol[IconSymbol["OpenDAW"] = 88] = "OpenDAW";
    IconSymbol[IconSymbol["Panel"] = 89] = "Panel";
    IconSymbol[IconSymbol["Peak"] = 90] = "Peak";
    IconSymbol[IconSymbol["Pencil"] = 91] = "Pencil";
    IconSymbol[IconSymbol["Piano"] = 92] = "Piano";
    IconSymbol[IconSymbol["Play"] = 93] = "Play";
    IconSymbol[IconSymbol["Playfield"] = 94] = "Playfield";
    IconSymbol[IconSymbol["PlayOnce"] = 95] = "PlayOnce";
    IconSymbol[IconSymbol["PlayRepeat"] = 96] = "PlayRepeat";
    IconSymbol[IconSymbol["PlayAlternate"] = 97] = "PlayAlternate";
    IconSymbol[IconSymbol["Pointer"] = 98] = "Pointer";
    IconSymbol[IconSymbol["Popout"] = 99] = "Popout";
    IconSymbol[IconSymbol["Primary"] = 100] = "Primary";
    IconSymbol[IconSymbol["Random"] = 101] = "Random";
    IconSymbol[IconSymbol["Record"] = 102] = "Record";
    IconSymbol[IconSymbol["Rectangle"] = 103] = "Rectangle";
    IconSymbol[IconSymbol["Redo"] = 104] = "Redo";
    IconSymbol[IconSymbol["Region"] = 105] = "Region";
    IconSymbol[IconSymbol["Robot"] = 106] = "Robot";
    IconSymbol[IconSymbol["RoundDown"] = 107] = "RoundDown";
    IconSymbol[IconSymbol["RoundUp"] = 108] = "RoundUp";
    IconSymbol[IconSymbol["Run"] = 109] = "Run";
    IconSymbol[IconSymbol["Sawtooth"] = 110] = "Sawtooth";
    IconSymbol[IconSymbol["Saxophone"] = 111] = "Saxophone";
    IconSymbol[IconSymbol["Scissors"] = 112] = "Scissors";
    IconSymbol[IconSymbol["Search"] = 113] = "Search";
    IconSymbol[IconSymbol["Shadertoy"] = 114] = "Shadertoy";
    IconSymbol[IconSymbol["Shutdown"] = 115] = "Shutdown";
    IconSymbol[IconSymbol["Sine"] = 116] = "Sine";
    IconSymbol[IconSymbol["Solo"] = 117] = "Solo";
    IconSymbol[IconSymbol["SoundFont"] = 118] = "SoundFont";
    IconSymbol[IconSymbol["Speaker"] = 119] = "Speaker";
    IconSymbol[IconSymbol["SpeakerHeadphone"] = 120] = "SpeakerHeadphone";
    IconSymbol[IconSymbol["Square"] = 121] = "Square";
    IconSymbol[IconSymbol["Stack"] = 122] = "Stack";
    IconSymbol[IconSymbol["Start"] = 123] = "Start";
    IconSymbol[IconSymbol["Stereo"] = 124] = "Stereo";
    IconSymbol[IconSymbol["Stop"] = 125] = "Stop";
    IconSymbol[IconSymbol["Subtract"] = 126] = "Subtract";
    IconSymbol[IconSymbol["Sun"] = 127] = "Sun";
    IconSymbol[IconSymbol["Swap"] = 128] = "Swap";
    IconSymbol[IconSymbol["System"] = 129] = "System";
    IconSymbol[IconSymbol["Table"] = 130] = "Table";
    IconSymbol[IconSymbol["Tape"] = 131] = "Tape";
    IconSymbol[IconSymbol["TapeReel"] = 132] = "TapeReel";
    IconSymbol[IconSymbol["Time"] = 133] = "Time";
    IconSymbol[IconSymbol["Timeline"] = 134] = "Timeline";
    IconSymbol[IconSymbol["Tone3000"] = 135] = "Tone3000";
    IconSymbol[IconSymbol["Tool"] = 136] = "Tool";
    IconSymbol[IconSymbol["Triangle"] = 137] = "Triangle";
    IconSymbol[IconSymbol["Undo"] = 138] = "Undo";
    IconSymbol[IconSymbol["Unknown"] = 139] = "Unknown";
    IconSymbol[IconSymbol["UserFolder"] = 140] = "UserFolder";
    IconSymbol[IconSymbol["Velocity"] = 141] = "Velocity";
    IconSymbol[IconSymbol["Vinyl"] = 142] = "Vinyl";
    IconSymbol[IconSymbol["Volume"] = 143] = "Volume";
    IconSymbol[IconSymbol["VUMeter"] = 144] = "VUMeter";
    IconSymbol[IconSymbol["Waveform"] = 145] = "Waveform";
    IconSymbol[IconSymbol["Zeitgeist"] = 146] = "Zeitgeist";
})(IconSymbol || (IconSymbol = {}));
(function (IconSymbol) {
    IconSymbol.toName = (symbol) => IconSymbol[symbol];
    IconSymbol.fromName = (name) => IconSymbol[name] ?? IconSymbol.Rectangle;
})(IconSymbol || (IconSymbol = {}));
